import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_JOB_PARTS: createSagaAction('GET_JOB_PARTS'),

  ADD_JOB_PART: createSagaAction('ADD_JOB_PART'),
  UPDATE_JOB_PART: createSagaAction('UPDATE_JOB_PART'),
  DELETE_JOB_PART: createSagaAction('DELETE_JOB_PART')
}

// Action Creators
export const actions = {
  getJobParts: ({ jobId }) => ({
    type: constants.GET_JOB_PARTS.ACTION,
    jobId
  }),

  addJobPart: ({ jobId, content, userId }) => ({
    type: constants.ADD_JOB_PART.ACTION,
    jobId,
    content,
    userId
  }),

  updateJobPart: ({ jobId, partId, userId, content }) => ({
    type: constants.UPDATE_JOB_PART.ACTION,
    jobId,
    partId,
    userId,
    content
  }),

  deleteJobPart: ({ partId, jobId }) => ({
    type: constants.DELETE_JOB_PART.ACTION,
    jobId,
    partId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_JOB_PARTS.SUCCESS:
      return {
        ...state,
        jobParts: action.payload
      }
    case constants.ADD_JOB_PART.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_JOB_PART.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_JOB_PART.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobPartActions.js